<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-board :config="config" />
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="显示所有未关闭的问题，不限时间！" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "lpa-left",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: this.beans,
      config: {
        startCharts: "",
        header: ["问题", "发现区域", "责任人", "日期"],
        headerBGC: "#018DCE",
        evenRowBGC: "#000D4A",
        rowNum: 4,
        columnWidth: [120],
        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        for (var i = 0; i < this.dataList.length; i++) {
          var time = "--";
          var issue = this.dataList[i]["title"];
          var owner = this.dataList[i]["owner"];
          var station = this.dataList[i]["station"];
          if (this.dataList[i]["date"] > 0) {
            time = this.dateFormat(this.dataList[i]["date"], "yyyy-MM-dd");
          }
          if (this.dataList[i]["expired"]) {
        //    issue = '<span style="color:red">' + issue + "</span>";
            time = '<span style="color:red">' + time + "</span>";
          }
          var value = [issue, station, owner, time];
          data.push(value);
        }

        this.config = {
          startCharts: "",
          header: ["问题", "发现区域", "责任人", "日期"],
          headerBGC: "#018DCE",
          evenRowBGC: "#000D4A",
          rowNum: 8,
          columnWidth: [710,120,90,90],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx) {
      return dateFormat(uninx, "MM/dd");
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>

<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/ehs/component/issue-list.vue